import { uploadRepository } from "../repositories";
import { Type } from "./type";
export const uploadModule = {
  namespaced: true,

  state: () => ({
    files: [],
  }),
  getters: {
    filesConvertToFormData(state) {
      if (state.files.length == 0) return state.files;
      let formData = new FormData();
      state.files.forEach((image) => formData.append("file", image));
      return formData;
    },
  },

  mutations: {
    [Type.UPLOAD_FILE_SET](state, payload) {
      state.files = [...payload];
    },
    [Type.UPLOAD_FILE_RESET](state) {
      state.files = [];
    },
  },
  actions: {
    async [Type.UPLOAD_FILE_ASYNC]({ commit, getters }, payload) {
      console.log(true);
      try {
        commit(Type.UPLOAD_FILE_SET, payload);
        const { data } = await uploadRepository.sendFile(
          getters.filesConvertToFormData
        );
        Promise.resolve(data?.data?.result);
      } catch (error) {
        Promise.reject(error);
      }
    },
  },
};
